var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMiniMusicSqaure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h2c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.08 20.56a2.19 2.19 0 1 1 4.379-.001 2.19 2.19 0 0 1-4.379.001zm1.5-.01c0 .38.31.69.69.69.38 0 .69-.31.69-.69 0-.38-.31-.69-.69-.69-.38 0-.69.31-.69.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.96 20.56v-5.82c0-.91.56-1.65 1.44-1.88l2.89-.79c.9-.25 1.46-.01 1.78.23.31.24.68.72.68 1.65v5.64c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5.64c0-.32-.07-.44-.1-.46-.03-.02-.17-.06-.48.02l-2.89.79c-.3.08-.33.29-.33.44v5.82a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.371 19.6a2.19 2.19 0 1 1 4.379-.001 2.19 2.19 0 0 1-4.379.001zm1.5-.01c0 .38.31.69.69.69.38 0 .69-.31.69-.69 0-.38-.31-.69-.69-.69-.38 0-.69.31-.69.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99 16.63a.75.75 0 0 1 .53-.92l5.29-1.44a.75.75 0 1 1 .39 1.45l-5.29 1.44c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMiniMusicSqaure);
export default __webpack_public_path__ + "static/media/vuesax-outline-mini-music-sqaure.8f6da5a2960a13256cec90cce854cbce.svg";
export { ForwardRef as ReactComponent };